import { Skeleton } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { COLORS } from '../../services/constants/colors';

export const EasSkeleton = () => {
	return (
		<Skeleton
			key={nanoid()}
			variant="rectangular"
			height="26px"
			sx={{
				mb: '26px',
				backgroundColor: `${COLORS.TABLE_ROW}!important`,
			}}
		/>
	);
};
